import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from "react-router-dom"; 
import { getFirestore, query, where, getDocs, orderBy, collection } from "firebase/firestore";
import { db } from "../firebase"; 
import { Randomcode } from '../components/rendom_code';
import { Helmet } from "react-helmet";  
import Lodinging from "../components/loading";  
import { useToast } from '../components/ToastContext';   
import Adminmenu from "./admin_menu";
import { Saveskills_categories } from './Save_skills_categories';
import { Savejobcategories } from './Save_jobcategories';
import './admin.css'; 
import Select from 'react-select'; // Import from 'react-select' not 'react-select/base'

export default function Adminjobcategories() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { showToast } = useToast();

  const [guid, setguid] = useState('');
  const [uid, setuid] = useState('');
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const [TypeInput, setTypeInput] = useState("");
  const [TitleInput, setTitleInput] = useState("");
  const [DescriptionInput, setDescriptionInput] = useState("");
  const [SlugInput, setSlugInput] = useState("");
  const [IconInput, setIconInput] = useState("");
  const [Skillscategories, setSkillscategories] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);

  // Fetching Skills Categories from Firestore
  useEffect(() => {
    const fetchSkillCategories = async () => {
      try {
        const q = query(collection(db, "skills_categories"), where("status", "==", true), orderBy("title"));
        const querySnapshot = await getDocs(q);
        const skills_categoriesList = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setSkillscategories(skills_categoriesList);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching skills categories:", error);
        setIsLoading(false);
      }
    };

    fetchSkillCategories();
  }, []);

  const options = Skillscategories.map((category) => ({
    value: category.skillsId,
    label: category.title,
  }));

  // Save Skills Categories
  const create_Saveskills_categories_btn = async (e) => {
    e.preventDefault(); 

    if (!TitleInput || !DescriptionInput || !SlugInput) {
      setLoading(false);
      showToast("Please fill in all fields.");
      return;
    }

    setLoading(true);

    const skillsId = Randomcode(8);
    console.log("Generated categoryId:", skillsId); 

    const result = await Saveskills_categories({
      skillsId,
      title: TitleInput,
      description: DescriptionInput,
      slug: SlugInput.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, ''),
      icon: IconInput,
    });

    if (result.success) {
      showToast("Successfully saved.");
      setSlugInput("");
      setTitleInput("");
      setDescriptionInput("");
      setLoading(false);
    } else {
      console.error("Save failed:", result.error);
      showToast("Failed: " + result.error);
      setLoading(false);
    }
  };
 
  // Save Job Categories
  const jobcategories_btn = async (e) => {
    e.preventDefault();

    if (!TitleInput || !DescriptionInput || !SlugInput) {
      setLoading(false);
      showToast("Please fill in all fields.");
      return;
    }

    setLoading(true);

    const result = await Savejobcategories({
      categoryId: Randomcode(9),     
     title:TitleInput,
       skillscategories:selectedOption.label,
      skillsId:selectedOption.value,
      description: DescriptionInput,
      slug: SlugInput.toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9\-]/g, ''),
      icon: IconInput,
    });

    if (result.success) {
      showToast("Successfully saved.");
      setSlugInput("");
      setTitleInput("");
      setDescriptionInput("");
      setLoading(false);
    } else {
      setLoading(false);
      showToast("Failed to publish post.");
    }
  };

  return (
    <div className="container_roots">
      <Adminmenu />
      <div className="admin-body">
        {/* Skills Categories Section */}
        <div className="job-categories-div">
          <h2>Skills Categories</h2>
          <table>
            <tr>
              <td>Name</td>
              <td>
                <input 
                  placeholder="Name" 
                  onChange={(e) => setTitleInput(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>Icon</td>
              <td>
                <input 
                  placeholder="URL" 
                  onChange={(e) => setIconInput(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>Slug</td>
              <td>
                <input 
                  placeholder="Slug" 
                  onChange={(e) => setSlugInput(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td>
                <textarea 
                  rows={2} 
                  placeholder="Description" 
                  onChange={(e) => setDescriptionInput(e.target.value)} 
                />
              </td>
            </tr>
          </table>
          <br />
          <div onClick={create_Saveskills_categories_btn} className="button">
            {loading ? <Lodinging /> : "Create"}
          </div>
        </div>

        {/* Job Categories Section */}
        <div className="job-categories-div">
          <h2>Skills Categories list</h2>
          <table>
            <tr>
              <td>Skills</td>
             
              </tr>
              <tr>
              <td>
                {isLoading ? (
                  <Lodinging />
                ) : (
                  <Select className='select_skils'
                    options={options}
                    onChange={(option) => setSelectedOption(option)}
                    placeholder="Select a skill category"
                  />
                )} 
              
              </td>
            </tr>
             
     
  
</table>
  
 
</div>

       {/* Job Categories Section */}
       <div className="job-categories-div">
          <h2>Job Categories</h2>
          <table>
          <tr>
  <td>Type</td>
  <td>
    {selectedOption?.label && selectedOption.label}
  </td>
</tr>
<tr>
  <td>SkillsId</td>
  <td>
    {selectedOption?.value && selectedOption.value}
  </td>
</tr>
            <tr>
              <td>Name</td>
              <td>
                <input 
                  placeholder="Name" 
                  onChange={(e) => setTitleInput(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>Icon</td>
              <td>
                <input 
                  placeholder="URL" 
                  onChange={(e) => setIconInput(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>Slug</td>
              <td>
                <input 
                  placeholder="Slug" 
                  onChange={(e) => setSlugInput(e.target.value)} 
                />
              </td>
            </tr>
            <tr>
              <td>Description</td>
              <td>
                <textarea 
                  rows={2} 
                  placeholder="Description" 
                  onChange={(e) => setDescriptionInput(e.target.value)} 
                />
              </td>
            </tr>
          </table>
          <br />
          <div onClick={jobcategories_btn} className="button">
            {loading ? <Lodinging /> : "Create"}
          </div>
        </div>
      </div>
    </div>
  );
}
